import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getAuth } from 'firebase/auth';

const ProtectedRoute = ({ children }) => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  const location = useLocation();

  useEffect(() => {
    console.log('ProtectedRoute rendered at path:', location.pathname);
    console.log('Current user in ProtectedRoute:', currentUser?.uid);
  }, [currentUser, location]);

  if (!currentUser) {
    // User is not authenticated, redirect to login
    console.log('No current user, redirecting to login from:', location.pathname);
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // User is authenticated, render the protected component
  console.log('User is authenticated, rendering children for path:', location.pathname);
  return <>{children}</>;
};

export default ProtectedRoute; 